import * as constants from '../constants'

const firstState = {
  isBasketModal: false,
  isLoginModal: false,
  donationData: {}
}

const getters = {

}

const mutations = {
  [constants.IS_BASKET_MODAL](state, payload) {
    state.isBasketModal = payload.isOpen
    state.donationData = payload.data
  },
  [constants.IS_LOGIN_MODAL](state, payload) {
    state.isLoginModal = payload.isOpen
  }
}
const actions = {
  toggleBasketModal({ commit }, payload) {
    commit(constants.IS_BASKET_MODAL, payload)
  },
  toggleLoginModal({ commit }, payload) {
    commit(constants.IS_LOGIN_MODAL, payload)
  }
}

export default {
  state: firstState,
  getters,
  mutations,
  actions
}
